<template>
  <!--  -->
  <div class="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
    <!--  -->
    <div-filter
      :name="configList.name"
      :config="configList"
      :filters="filters"
      :currentUser="currentUser"
      :idWharhouse="idWharhouse"
      @reset="reset"
      @filtrer="filtrer"
      @search="search"
      :loading="loading"
    />
    <!--  -->

    <div :class="configList.class">
      <!--  -->
      <div
        class="bg-white rounded-lg overflow-hidden border border-slate-200 transform transition-all duration-300"
      >
        <!--  -->
        <div
          class="p-6 border-b border-slate-200 bg-gradient-to-r from-green-100 to-blue-200 flex items-center justify-between"
        >
          <!--  -->
          <div class="flex items-center">
            <!--  -->
            <div class="bg-primary p-2 rounded-lg shadow-md text-white mr-4">
              <!--  -->
              <Icon icon="mdi:shopping-outline" class="text-2xl" />
              <!--  -->
            </div>
            <!--  -->
            <h2 class="text-xl font-semibold text-slate-800">
              <!--  -->
              <span class="text-primary"> Marketplace</span>
              <!--  -->
            </h2>
            <!--  -->
          </div>
          <!--  -->

          <div
            v-on-clickaway="awayLimit"
            v-if="configList.awayLimit"
            class="relative"
          >
            <!--  -->
            <button
              @click="openLimit = !openLimit"
              class="flex items-center px-4 py-2 bg-white border border-slate-200 rounded-lg hover:bg-green-50 transition-all duration-300 group"
            >
              <!--  -->
              <span
                class="text-sm font-medium text-slate-700 group-hover:text-primary"
              >
                <!--  -->
                {{ paginate.currentpage || 1 }} - {{ charges.length }} /
                {{ paginate.total || charges.length }}
              </span>
              <!--  -->
              <Icon
                icon="mdi:chevron-down"
                class="text-slate-500 ml-2 group-hover:text-primary transition-all duration-300"
              />
              <!--  -->
            </button>
            <!--  -->

            <div class="relative">
              <!--  -->
              <div
                v-if="openLimit"
                class="absolute right-0 mt-2 w-32 bg-white rounded-lg shadow-base border border-slate-200 z-30 transform transition-all duration-300 animate-fadeIn"
              >
                <!--  -->
                <div class="py-1">
                  <!--  -->
                  <a
                    v-for="limit in [32, 80, 160, 320, 480]"
                    :key="limit"
                    @click="Changelimit(limit)"
                    v-show="limit <= 80 || currentUser.type !== 'Seller'"
                    class="block px-4 py-2 text-sm text-slate-700 hover:bg-green-50 hover:text-primary cursor-pointer transition-all duration-200"
                  >
                    <!--  -->
                    {{ limit }}
                  </a>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <loading
          v-if="!isMounted"
          :active.sync="loading"
          :is-full-page="fullPage"
        >
        </loading>
        <!--  -->

        <div class="p-6">
          <!--  -->
          <div
            v-if="isMounted && loading"
            class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
          >
            <!--  -->
            <div
              v-for="ind in 8"
              :key="ind"
              class="bg-white rounded-lg border border-slate-200 overflow-hidden animate-pulse"
            >
              <!--  -->
              <div class="aspect-w-1 aspect-h-1 bg-slate-200"></div>
              <!--  -->
              <div class="p-4">
                <!--  -->
                <div class="h-6 bg-slate-200 rounded mb-3"></div>
                <!--  -->
                <div class="h-4 bg-slate-200 rounded mb-2 w-3/4"></div>
                <!--  -->
                <div class="h-4 bg-slate-200 rounded mb-2 w-1/2"></div>
                <!--  -->
                <div class="h-8 bg-slate-200 rounded mt-4"></div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <div
            v-else
            class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
          >
            <!--  -->
            <div
              v-for="(item, index) in charges"
              :key="index"
              :class="{
                'ring-2 ring-green-500 ring-offset-4':
                  dataSelected.loading &&
                  dataSelected.data._id &&
                  dataSelected.data._id.toString() === item._id.toString(),
              }"
              class="bg-white rounded-lg border border-slate-200 overflow-hidden transform transition-all duration-300 hover:shadow-base hover:-translate-y-1 group relative"
            >
              <!--  -->
              <div class="relative overflow-hidden">
                <!--  -->
                <div class="absolute top-3 left-3 px-3 py-1 bg-green-500 rounded-full text-white text-xs z-10 font-medium tracking-wide shadow-md">
                  <!--  -->
                  Marketplace
                </div>
                <div
                v-if="
                  currentUser.type === 'Seller' &&
                  item.seller.toString() === currentUser._id.toString()
                "
                class="absolute top-10 left-3 px-3 py-1 bg-black-500 rounded-full text-white text-xs z-10 font-medium tracking-wide shadow-md"
              >
                <!--  -->
                VOTRE PRODUIT
              </div>
                <!--  -->
                <router-link
                  :to="{ path: `/marketplaces/products/${item._id}` }"
                >
                  <!--  -->
                  <div class="relative">
                    <!--  -->
                    <img
                      :src="item.picture"
                      class="w-full h-56 object-cover transform transition-all duration-700 group-hover:scale-110"
                      alt=""
                    />
                    <!--  -->
                    <div
                      class="absolute inset-0 bg-gradient-to-t from-slate-900 to-transparent opacity-0 group-hover:opacity-40 transition-opacity duration-300"
                    ></div>
                    <!--  -->
                  </div>
                  <!--  -->
                </router-link>
                <!--  -->
              </div>
              <!--  -->

              <div class="p-4">
                <!--  -->
                <h3
                  class="font-semibold text-slate-800 mb-2 line-clamp-1 text-lg group-hover:text-primary transition-colors duration-300"
                >
                  <!--  -->
                  {{ item.name }}
                </h3>
                <!--  -->

                <div class="flex items-center text-slate-600 text-sm mb-2">
                  <!--  -->
                  <span
                    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800"
                  >
                    <!--  -->
                    <Icon icon="mdi:tag-outline" class="mr-1" />
                    <!--  -->
                    {{ item.category }}
                  </span>
                  <!--  -->
                </div>
                <!--  -->

                <div class="flex items-center text-slate-600 text-sm mb-3">
                  <!--  -->
                  <span class="mr-2 text-slate-500"> Country:</span>
                  <!--  -->
                  <div class="flex -space-x-1 overflow-hidden">
                    <!--  -->
                    <span v-for="(detialPr, r) in item.details" :key="r">
                      <!--  -->
                      <img
                        :src="
                          'https://static.dwcdn.net/css/flag-icons/flags/4x3/' +
                          detialPr.country.toLowerCase() +
                          '.svg'
                        "
                        class="w-5 h-5 rounded-full inline-block border border-white"
                      />
                      <!--  -->
                    </span>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->

                <div class="flex items-center justify-between mt-4">
                  <!--  -->
                  <!-- <div class="text-primary font-semibold text-lg">
                   
                    {{ getPrice(item.details)}} CFA
                  </div> -->
                  <!--  -->

                  <!-- <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
                        <div v-for="(productMarket, p) in item.details" :key="p" class="flex items-center justify-between rounded-lg border p-1 bg-gray-50">
                          <div class="flex items-center gap-2">
                            <span class="pr-2 text-xl"><img class="w-5 h-5 rounded-full inline-block border border-white" :src="'https://static.dwcdn.net/css/flag-icons/flags/4x3/' +productMarket.country.toLowerCase() +'.svg'"/></span>
                          </div>
                          <span class="text-teal-600 font-semibold">{{productMarket.priceMarket}} </span>
                          <span class="pl-2 text-sm font-semibold text-teal-600">CFA</span>
                        </div>
                    </div> -->

                    <div class="space-y-1 w-full mr-1"> 
                      <div
                        v-for="(group, index) in getPrice(item.details)"
                        :key="index"
                        class="flex items-center justify-between border p-1 rounded-lg bg-gray-50"
                      >
                        <div class="flex items-center gap-1 flex-wrap"> 
                          <span
                            v-for="country in group.countries"
                            :key="country.country"
                            class="text-sm pr-1"
                            :title="country.country"
                          >
                            <img class="w-4 h-4 rounded-full inline-block border border-white" :src="'https://static.dwcdn.net/css/flag-icons/flags/4x3/' +country.country.toLowerCase() +'.svg'"/>
                          </span>
                        </div>
                        <span class="text-teal-600 font-semibold">
                          {{ group.priceMarket }} CFA
                        </span>
                      </div>
                    </div>


                  <router-link
                    :to="{ path: `/marketplaces/products/${item._id}` }"
                    class="p-2 bg-blue-50 text-blue-400 hover:bg-blue-100 hover:text-blue-600 transition-colors rounded-full"
                  >
                    <!--  -->
                    <Icon icon="mdi:eye-outline" class="text-xl" />
                    <!--  -->
                  </router-link>
                  <!--  -->
                </div>
                <!--  -->

                <div
                  class="flex items-center justify-between pt-4 mt-4 border-t border-slate-200"
                >
                  <!--  -->
                  <div
                    class="flex items-center"
                    v-if="currentUser.type !== 'Seller'"
                  >
                    <!--  -->
                    <router-link
                      v-if="
                        $f.getAccess(
                          currentUser.role.permissions,
                          'marketplaces',
                          'update'
                        )
                      "
                      :to="{ path: `/products/edit/${item._id}` }"
                      target="_blank"
                      class="p-2 bg-green-50 text-green-400 hover:bg-green-100 hover:text-green-600 transition-colors rounded-full mr-2"
                    >
                      <!--  -->
                      <Icon icon="mdi:pencil-outline" />
                      <!--  -->
                    </router-link>
                    <!--  -->

                    <button
                      v-if="
                        $f.getAccess(
                          currentUser.role.permissions,
                          'marketplaces',
                          'delete'
                        )
                      "
                      @click="remove(item._id, index)"
                      :disabled="dataSelected.loading"
                      class="p-2 bg-red-50 text-red-400 hover:bg-red-100 hover:text-red-600 rounded-full relative transition-colors"
                    >
                      <!--  -->
                      <loading
                        v-if="
                          dataSelected.data._id &&
                          dataSelected.data._id.toString() ===
                            item._id.toString()
                        "
                        :active.sync="dataSelected.loading"
                        :is-full-page="fullPage"
                      >
                      </loading>
                      <!--  -->

                      <!--  -->
                      <Icon icon="mdi:delete-outline" />
                      <!--  -->
                    </button>
                    <!--  -->
                  </div>
                  <!--  -->

                  <div v-if="currentUser.type !== 'Seller'" class="relative">
                    <!--  -->
                    <select
                      :disabled="dataSelected.loading"
                      @change="ChangeStatus(item, index, 'products')"
                      :class="
                        item.visibility === 'public'
                          ? 'text-primary border-primary bg-white'
                          : 'text-slate-600 border-slate-200 bg-slate-50'
                      "
                      class="py-1.5 px-4 text-xs capitalize rounded-full border transition-all duration-300 focus:outline-none focus:ring-1 focus:ring-primary font-medium"
                      v-model="item.visibility"
                    >
                      <!--  -->
                      <option value="public">Public</option>
                      <!--  -->
                      <option value="private">Private</option>
                      <!--  -->
                    </select>
                    <!--  -->
                    <loading
                      v-if="
                        dataSelected.data._id &&
                        dataSelected.data.name &&
                        dataSelected.data._id.toString() === item._id.toString()
                      "
                      :active.sync="dataSelected.loading"
                      :is-full-page="fullPage"
                    >
                    </loading>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <Button
                v-if="
                  currentUser.type === 'Seller' &&
                  item.seller.toString() !== currentUser._id.toString()
                "
                class="px-4 pb-4"
                btnClass="w-full btn-sm btn-primary rounded-lg"
                iconClass="text-lg"
                icon="mdi:cart-plus"
                :disabled="dataSelected.loading"
                :loading="dataSelected.loading"
                :text="$t('request_product')"
                @click="OpenClosePopupModal('open', 'ProductMarketplace', item)"
              />
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <div
          class="p-6 border-t border-slate-200 bg-slate-50"
          v-if="paginate.lastpage > 1"
        >
          <!--  -->
          <div class="flex justify-center">
            <!--  -->
            <DivPagination :paginate="paginate" @paginatation="paginatation" />
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->
    </div>
    <!--  -->

    <requestMOdal
      :currentUser="currentUser"
      :idWharhouse="idWharhouse"
      :loading="dataSelected.loading"
      :data="dataSelected.data"
      @OpenClosePopupModal="OpenClosePopupModal"
      @EmitActionNewShipp="EmitActionNewShipp"
    />
    <!--  -->
  </div>
  <!--  -->
</template>

<script>
import config from "./config";
import requestMOdal from "../components/request";
export default {
  components: {
    requestMOdal,
  },
  props: {
    currentUser: { type: Object },
    idWharhouse: { type: Object },
  },
  data() {
    return {
      configList: config.list,
      openLimit: false,
      loading: false,
      isMounted: false,
      formData: {},
      charges: [],
      sellers: [],
      tabId: [],
      limit: 16,
      filters: {},
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 0,
        per_page: 0,
      },
      currentSettings: { info: { currency: "" } },
      currentSettingsGlobal: { info: { currency: "" } },
      dataSelected: { loading: false, data: {} },
      fullPage: false,
    };
  },
  computed: {
    warhouseSelected() {
      return this.$store.getters["wharhouse/warhouseSelected"]({
        user: _.pick(this.currentUser, ["countries"]),
      });
    },
  },
  watch: {
    warhouseSelected: async function (oldVal, newVal) {},
    idWharhouse: async function (oldVal, newVal) {
      this.idWharhouse = oldVal;
      await this.reset();
    },
  },
  async mounted() {
    if (
      this.currentUser.type === "Seller" &&
      !this.currentUser.accountType.includes("affiliate") &&
      !this.currentUser.accountType.includes("cpa")
    ) {
      this.$store.dispatch("actionloadingpage", { loading: false });
      this.$toast.warning("You don't have access to Affiliate");
      return this.$router.push("/profile");
    }

    this.isMounted = true;

    if (this.currentUser.type === "Seller") {
      let pos = this.configList.columns
        .map(function (e) {
          return e.name;
        })
        .indexOf("Visibility");
      if (pos != -1) this.configList.columns.splice(pos, 1);
      let pos1 = this.configList.filters.elements.champs
        .map(function (e) {
          return e.key;
        })
        .indexOf("visibility");
      if (pos1 != -1) this.configList.filters.elements.champs.splice(pos1, 1);
    } else {
      let pos = this.configList.columns
        .map(function (e) {
          return e.name;
        })
        .indexOf("Request");
      if (pos != -1) this.configList.columns.splice(pos, 1);
    }
    if (this.$f.QueryStringToobject())
      this.filters = this.$f.QueryStringToobject();
    else this.$f.objectToQueryString({ limit: this.limit });

    if (!this.filters.limit) this.filters.limit = this.limit;

    this.setDataSelect("visibility", ["public", "private"], null);
    this.setDataSelect("category", this.$f.defaultCategories(), null);

    this.setDataSelect("warehouse", this.currentUser.countries, null);
    this.currentSettingsGlobal=this.$store.state.settings;
    this.currentSettings = this.$store.state.settings.find(
      (el) => el.country === this.idWharhouse.country
    );

    if (this.filters.name) await this.search(this.filters.name);
    else await this.getAvoirs(this.filters);
  },
  methods: {
    getPrice(datas){
       let price=0;

       if(datas.length>0){
           const conversion= this.$f.getSettingByCountry(this.currentSettingsGlobal,datas[0].country);
           const conversionWarehouseDefault= this.$f.getSettingByCountry(this.currentSettingsGlobal,this.idWharhouse.country);

          // price = Math.trunc(datas.length === 1 ? datas[0].priceMarket : parseInt((datas[0].priceMarket) / conversion.info.currencyUSD) * conversionWarehouseDefault.info.currencyUSD);
         // price = Math.trunc(datas[0].priceMarket);

          const groups = {};

          datas.forEach(({ country , priceMarket }) => {
            if (!groups[priceMarket]) {
              groups[priceMarket] = { priceMarket, countries: [] };
            }
            groups[priceMarket].countries.push({ country });
          });

          price= Object.values(groups);
       }

       return price;
    },
    awayLimit() {
      this.openLimit = false;
    },
    async OpenClosePopupModal(action, method = "", dataItem) {
      if (action === "open") {
        this.dataSelected.data = dataItem;
        this.$vm2.open(method);
      } else {
        if (this.dataSelected.loading) return false;
        this.dataSelected.data = {};
        this.$vm2.close(method);
      }
    },
    async EmitActionNewShipp(name, statusName = null, dataAction) {
      if (name == "Marketplace") {
        //  console.log('statusName-------',statusName)
        // console.log('dataAction-------',dataAction)
        // return false
        if (dataAction.length === 0) return this.$toast.warning("Warehouses obligatoir !");

        for (const j in dataAction) {
          const dataElement = dataAction[j];

          if ((dataElement.info.quantity && !parseFloat(dataElement.info.quantity)) || !dataElement.info.quantity ) {
              return this.$toast.warning(`Quantity stock obligatoir (${dataElement.name})`);
              break;
          }

          if (!this.$f.isNumeric(dataElement.info.quantity)) {
              return this.$toast.warning("Please enter a valid Quantity");
              break;
          }

          if (!this.$f.isValidAmount(dataElement.info.quantity)) {
            return this.$toast.warning("Please enter a valid Quantity !");
            break;
          }

          if(parseInt(dataElement.info.stock) < parseInt(dataElement.info.quantity)){
              return this.$toast.warning(`La Quantité choisie est supérieure à la quantité disponible en stock au ${dataElement.name}.`);
              break; 
          }

            const index = statusName.details.findIndex(
              (item) =>
                item.warehouse._id.toString() === dataElement._id.toString()
            );
            if (index !== -1) {
              statusName.details[index].info = {
                quantity: dataElement.info.quantity,
                warehouse: _.pick(dataElement, [
                  "_id",
                  "name",
                  "country",
                  "currency",
                ]),
              };
            }
          
        }

        this.$confirm(
          this.currentUser.type === "Seller"
            ? "Êtes-vous sûr de demande du product ?"
            : "Êtes-vous sûr de changement de statut ?"
        ).then(async (res) => {
          if (res) {
            
            if (this.currentUser.type !== "Seller" && statusName) statusName.status = statusName;
            else statusName.type = 'product';

            this.dataSelected.loading = true;
            const { content: dataAffiliate } = await this.$server.create(
              "marketplaces",
              statusName
            );
            this.dataSelected.loading = false;
            if (dataAffiliate && dataAffiliate._id) {
              this.OpenClosePopupModal("close", "ProductMarketplace");
              this.dataSelected.data = {};
              if (this.currentUser.type !== "Seller") await this.refresh();
              else{
                this.$router.push('/marketplaces/requests')
                return this.$toast.success("Votre demande a ete envoyé avec succès");
              }
              return this.$toast.success("Status updated");
            } else return this.$toast.warning(dataAffiliate);
          }
        });
      }
    },
    async remove(id, index) {
      this.$confirm(this.$t("you_sure")).then(async (res) => {
        if (res) {
          this.dataSelected.data = { _id: id };
          this.dataSelected.loading = true;
          const data = await this.$server.delete("products", { _id: id });
          this.dataSelected.loading = false;
          if (data && data._id) {
            this.charges = this.charges.filter(
              (el) => el._id.toString() !== data._id.toString()
            );
            this.dataSelected.data = {};
            return this.$toast.success(`Offre deleted`);
          } else return this.$toast.warning(data);
        }
      });
    },
    async getwharhouseId() {
      await this.$store
        .dispatch("wharhouse/getwharhouseId", {
          country: this.warhouseSelected,
        })
        .then((res) => {
          this.idWharhouse = res;
        });
    },
    getStyleByName(name) {
      var colorsNmae = [
        { name: "private", style: "color:red;border: 1px solid red;" },
        { name: "public", style: "color:green;border: 1px solid green" },
        { name: "pending", style: "color:orange;border: 1px solid orange" },
        { name: "approved", style: "color:green;border: 1px solid green" },
        { name: "rejected", style: "color:red;border: 1px solid red" },
      ];
      if (colorsNmae.find((el) => el.name === name.toLowerCase()))
        return colorsNmae.find((el) => el.name === name.toLowerCase()).style;
    },
    async ChangeStatus(dataToEdit, index, name) {
      this.$confirm("Est vous sûre pour faire le changement ?").then(
        async (res) => {
          if (res) {
            let bodyData = {
              _id: dataToEdit._id,
              visibility: dataToEdit.visibility,
              oldVisibility: dataToEdit.oldVisibility,
            };
            this.dataSelected.data = dataToEdit;
            this.dataSelected.loading = true;
            const {content:data} = await this.$server.update("marketplaces", bodyData);
            this.dataSelected.loading = false;
            this.dataSelected.data = {};

            if (data && data._id) {
              this.charges[index].visibility = dataToEdit.visibility;
              return this.$toast.success(`Updated successfully`);
            } else {
              this.charges[index].visibility = dataToEdit.oldVisibility;
              return this.$toast.warning(data);
            }
          }
        }
      );
    },
    async GeneratePayment(data, index) {
      this.$confirm("Êtes-vous sûr de demander cette offre ?").then(
        async (res) => {
          if (res) {
            this.dataSelected.data = data;
            this.dataSelected.loading = true;

            const { content: dataAffiliate } = await this.$server.create(
              "marketplaces",
              data
            );
            this.dataSelected.loading = false;

            this.dataSelected.data = {};
            if (dataAffiliate && dataAffiliate._id)
              this.$toast.success("Votre demande a ete envoyé avec succès");
            else this.$toast.warning(dataAffiliate);

            setTimeout(() => (this.loading = false), 1200);
            await this.refresh();
          }
        }
      );
    },
    setDataSelect(model, data, splice) {
      for (var i = 0; i < this.configList.filters.elements.champs.length; i++) {
        if (
          this.configList.filters.elements.champs[i].type === "select" &&
          this.configList.filters.elements.champs[i].key === model
        ) {
          if (!splice) {
            this.configList.filters.elements.champs[i].values = data;
          } else {
            this.configList.filters.elements.champs.splice(i, 1);
          }
        }
      }
    },
    async getSellers() {
      const filter = {
        type: "Seller",
        limit: 10,
      };
      if (this.currentUser.type != "Seller") {
        const res = await this.$server.search("users", filter);
        if (res.content.results) this.sellers = res.content.results;
        else this.sellers = [];
      }
    },
    async Changelimit(val) {
      if (this.$f.QueryStringToobject())
        this.filters = this.$f.QueryStringToobject();
      this.filters["limit"] = val;
      this.filters["page"] = 1;
      this.paginate.currentpage = 1;
      this.$f.objectToQueryString(this.filters);
      if (this.filters.name) await this.search(this.filters.name);
      else this.getAvoirs(this.filters);
    },
    async filtrer(data) {
      if (this.$f.QueryStringToobject())
        this.filters = this.$f.QueryStringToobject();
      delete this.filters.page;
      delete this.filters.name;

      this.paginate.currentpage = 1;
      if (!this.filters["limit"]) this.filters["limit"] = this.limit;
      if (data.warehouse) {
        this.filters["details.country"] = data.warehouse.code;
      } else delete this.filters["details.country"];
      if (data.category) {
        this.filters.category = data.category;
      } else delete this.filters.category;
      if (data.visibility) {
        this.filters.visibility = data.visibility;
      } else delete this.filters.visibility;
      if (data.Range_date && data.Range_date[0]) {
        this.filters.Range_date = data.Range_date.map((el) =>
          this.$moment(el).format("yyyy-MM-DD")
        );
      } else delete this.filters.Range_date;
      this.$f.objectToQueryString(this.filters);
      await this.getAvoirs(this.filters);
    },
    async reset() {
      let lmitt = this.limit;
      if (this.$f.QueryStringToobject())
        this.filters = this.$f.QueryStringToobject();
      if (this.filters["limit"]) lmitt = this.filters["limit"];
      this.filters["page"] = 1;
      this.$f.objectToQueryString({ limit: lmitt });
      await this.getAvoirs({ limit: lmitt });
    },
    async refresh() {
      if (this.$f.QueryStringToobject())
        this.filters = this.$f.QueryStringToobject();
      this.$f.objectToQueryString(this.filters);
      if (this.filters.name) await this.search(this.filters.name);
      else await this.getAvoirs(this.filters);
      if (
        this.filters["page"] &&
        this.filters["page"] > 1 &&
        this.charges.length == 0
      ) {
        this.filters["page"] = --this.filters["page"];
        this.$f.objectToQueryString(this.filters);
        await this.getAvoirs(this.filters);
      }
    },
    async getAvoirs(filters) {
      this.loading = true;
      filters.offers = true;
      const res = await this.$server.search("marketplaces", filters);
      this.loading = false;
      this.isMounted = false;
      if (res && res.content.results) {
        this.charges = res.content.results;
        this.charges.forEach(
          function (offre) {
            offre.oldVisibility = offre.visibility;
          }.bind(this)
        );
        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
      } else {
        this.charges = [];
        this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
      }
    },
    async search(data) {
      this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
      let limitt = this.limit;
      if (this.filters["limit"]) limitt = this.filters["limit"];
      const search = {
        name: data.trim(),
        limit: parseInt(limitt),
        offers: true,
      };

      this.$f.objectToQueryString(search);
      this.loading = true;
      const res = await this.$server.find("marketplaces", search);
      this.loading = false;
      this.isMounted = false;
      if (res.content.results) {
        this.charges = res.content.results;
        this.charges.forEach(
          function (offre) {
            offre.oldVisibility = offre.visibility;
          }.bind(this)
        );
        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
      } else {
        this.charges = [];
        this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
      }
    },
    async paginatation(direction) {
      let page = 0;

      if (
        direction === "next" &&
        this.paginate.currentpage < this.paginate.lastpage
      ) {
        page = ++this.paginate.currentpage;
      } else if (direction === "prev" && this.paginate.currentpage > 1) {
        page = --this.paginate.currentpage;
      } else if (
        direction.type === "goto" &&
        direction.page >= 1 &&
        direction.page <= this.paginate.lastpage
      ) {
        page = this.paginate.currentpage = direction.page;
      }

      if (this.$f.QueryStringToobject()) {
        this.filters = this.$f.QueryStringToobject();
      }

      this.filters["page"] = page;
      this.$f.objectToQueryString(this.filters);

      this.getAvoirs(this.filters);
    },
  },
};
</script>

<style scoped>
.animate-fadeIn {
  animation: fadeIn 0.3s ease-out forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
